module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/10m-891d15f3d419a208b54bfb905a93e644.jpg";